import './src/css/global.css'
import React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import { linkResolver } from './src/utils/link_resolver'

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
        linkResolver,
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
)